module.exports = __webpack_public_path__ + "assets/style.53af5ff1.svg";